<template>
    <div>
        <h4 class="mb-2">Additional Information</h4>
        <div v-for="q in questions" class="bg-light border rounded p-3 mb-3">
            <form-custom-checkbox v-if="q.QuestionType == 'Checkbox'" :question="q" v-model="value[q.QuestionID]"></form-custom-checkbox>
            <form-custom-radio v-if="q.QuestionType == 'Radio'" :question="q" v-model="value[q.QuestionID]"></form-custom-radio>
            <form-custom-textbox v-if="q.QuestionType == 'Textbox'" :question="q" v-model="value[q.QuestionID]"></form-custom-textbox>
            <form-custom-select v-if="q.QuestionType == 'Dropdown'" :question="q" v-model="value[q.QuestionID]"></form-custom-select>
            <div class="text-muted question-id">{{ q.QuestionID }}</div>
        </div>
    </div>
</template>

<script>
import FormCustomCheckbox from './FormCustomCheckbox.vue';
import FormCustomRadio from './FormCustomRadio.vue';
import FormCustomTextbox from './FormCustomTextbox.vue';
import FormCustomSelect from './FormCustomSelect.vue';

export default {
    components: {
        FormCustomCheckbox,
        FormCustomRadio,
        FormCustomSelect,
        FormCustomTextbox,
    },

    props: {
        questions: {
            type: Array,
            default: function(data=[]) {
                return data;
            },
        },
    },

    updated() {
        this.$emit('input', this.value);
    },

    data() {
        return {
            value: {},
        };
    }
}
</script>

<style scoped>
.question-id {
    font-size: x-small;
    text-align: right;
    margin-bottom: -1em;
}
</style>